var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('LoginForm',{on:{"showTerms":function($event){_vm.showTerms = true}}}),_c('LoginTerms',{attrs:{"show":_vm.showTerms},on:{"update:show":function($event){_vm.showTerms=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }